import cn from "classnames";
import Link from "next/link";
import type { FC, ButtonHTMLAttributes } from "react";
import type { ReactNode } from "react-markdown/lib/react-markdown";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ReactNode;
  href?: string;
  className?: string;
  isExternal?: boolean;
}

export const IconButton: FC<ButtonProps> = ({
  icon,
  href,
  className,
  isExternal,
  ...props
}) => {
  const buttonStyle = cn(
    "w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-bg",
    className
  );

  if (href) {
    return (
      <Link
        target={isExternal ? "_blank" : "_self"}
        rel={isExternal ? "noreferrer noopener" : ""}
        href={href}
      >
        <div className={buttonStyle}>{icon}</div>
      </Link>
    );
  }

  return (
    <button type="button" className={buttonStyle} {...props}>
      {icon}
    </button>
  );
};
